import axiosInstance from '../../../../config/axiosInstance';
import { AgreementValidation } from "../../../Setup/views/Agreement/Validation/AgreementValidation";

const handleChange = (event, formData, setFormData) => {
  const { name, value } = event.target;
  setFormData({
    ...formData,
    [name]: value,
  });
};

const handleSubmit = async (formData, setFormData, setErrors, redirectCallback, redirectUserList) => {
  const formErrors = AgreementValidation(formData);
  setErrors(formErrors);
  if (Object.keys(formErrors).length === 0) {
    try {
      const CompanyID = localStorage.getItem("CompanyID");
      const UserID = localStorage.getItem("UserID");
      const formDataToSend = new FormData();
      formDataToSend.append('ClientID', CompanyID);
      formDataToSend.append('UserID', UserID);
      Object.keys(formData).forEach(key => {
        if (key !== 'File') { // Skip the File key, we will handle it separately
          formDataToSend.append(key, formData[key]);
        }
      });
      if (formData.File) {
        formDataToSend.append('File', formData.File);
      }
      const config = {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      };
      debugger;
      const response = await axiosInstance.post(`/SuperAdmin/UpdateCompanyTermCondition`, formDataToSend, config);
      if (response.data) {
        setFormData(response.data);
      }
      return response;
    } catch (error) {
      if (error.response.data.message === "Invalid token") {
        redirectCallback();
        return;
      }
      console.error('Error posting data:', error);
    }
  }
};

export { handleChange, handleSubmit };
